import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import { FAQValidationSchema } from "../../../helpers/validationSchema";
import { FormLabel, TextareaAutosize } from "@material-ui/core";
import { CustomInputField } from "../../common/FormInputs";
import styled, { css } from "styled-components";
import COLORS from "../../../assets/Colors";
import theme from "../../../assets/theme";
import { ButtonWrapper } from "../Speakers";
import { AddCircleOutline } from "@material-ui/icons";
import { PrimaryCTAButton, SecondaryCTAButton } from "../../common/Buttons";
import ActionBar from "../../common/ActionBar";
import useLoader from "../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import EventService from "../../../services/EventService";
import _ from "lodash";
import { getErrorMessage } from "../../../helpers/functions";
import { navigate } from "@reach/router";
import { FormControl, ButtonContainer } from "../FormInputs";

const custom_buttons = [
  {
    label: "SAVE",
    color: "default",
    primary: true,
    name: "save",
  },
  {
    label: "SAVE & NEXT",
    color: "primary",
    secondary: true,
    name: "save&next",
  },
  {
    label: "CLEAR FORM",
    color: "secondary",
    clearForm: true,
  },
];

const Help = (id) => {
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();
  const [clickedButton, setClickedButton] = useState("");
  const [items, setItems] = useState();

  function addSection(setFieldValue, sections) {
    let newSections = [...sections, { question: "", answer: "" }];
    setFieldValue("sections", newSections);
  }

  function handleRemove(sections, index, setFieldValue) {
    let returnData = sections.filter((section, id) => id !== index);
    setFieldValue("sections", returnData);
  }

  useEffect(() => {
    async function getEventInfo() {
      try {
        setLoader({ state: true, message: "Fetching help..." });
        const response = await EventService.getEvent(id?.id, "help");
        if (response?.help !== null) {
          setItems(response);
        } else {
          setItems({ help: [] });
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoader({ state: false });
        window.scrollTo(0, 0);
      }
    }
    if (id?.id) {
      getEventInfo();
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getEventInfo() {
    try {
      setLoader({ state: true, message: "Fetching help..." });
      const response = await EventService.getEvent(id?.id, "help");
      setItems(response);
    } catch (err) {
      const message = getErrorMessage(err);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  /**
   * @description submit Polling
   */

  async function onFormSubmit(values) {
    try {
      setLoader({ state: true, message: "please wait..." });
      // const payload = {
      //   help: values?.sections,
      // };
      let cleanedFaq = [...values.sections];
      const last = cleanedFaq[cleanedFaq.length - 1];
      const isLastEmpty = !last?.question?.trim() && !last?.answer?.trim();
      if (isLastEmpty) cleanedFaq.pop();

      const payload = {
        help: cleanedFaq.length ? cleanedFaq : [],
      };
      const response = await EventService.updateEvent(id?.id, payload);
      if (response) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
      if (clickedButton === "save") {
        getEventInfo();
      } else {
        navigate(`/dashboard/eventmanager/tickers/${id?.id}`);
      }
    } catch (err) {
      enqueueSnackbar(err?.message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  const onBreadcrumbClick = (selected) => {
    switch (_.snakeCase(selected)) {
      case "event_manager":
        navigate(`/dashboard/eventmanager/home`);
        break;
      case "faq":
        id?.id
          ? navigate(`/dashboard/eventmanager/faqs/${id?.id}`)
          : navigate(`/dashboard/eventmanager/faqs`);
        break;
      default:
        break;
    }
  };

  /**
   * @description handle button click
   */

  const handleButtonClick = (button, resetForm, handleSubmit) => {
    if (button.clearForm) {
      resetForm();
    } else {
      setClickedButton(button.name); // Store clicked button
      handleSubmit();
    }
  };

  return (
    <>
      <ActionBar
        breadcrumbs={
          id?.id
            ? [
                "Event Manager",
                "Faq",
                "Help",
                items?.eventName
                  ? `${items?.eventName} (${items?.eventDate})`
                  : "",
              ]
            : ["Event Manager", "Faq", "Help"]
        }
        {...{ onBreadcrumbClick }}
      />
      <Container>
        <Formik
          initialValues={{
            sections:
              items?.help.length > 0
                ? [...items?.help]
                : [{ question: "", answer: "" }],
          }}
          validateOnBlur={false}
          enableReinitialize
          validationSchema={FAQValidationSchema}
          validateOnChange
          onSubmit={onFormSubmit}
        >
          {({
            values,
            handleChange,
            errors,
            handleSubmit,
            touched,
            handleBlur,
            setFieldValue,
            resetForm,
          }) => (
            <form onSubmit={handleSubmit}>
              {values.sections.map((section, sec_index) => (
                <Section key={sec_index}>
                  <Width>
                    <Row>
                      <H2>ITEM {sec_index + 1}</H2>
                      {items?.help.length >= 1 && (
                        <img
                          onClick={() =>
                            handleRemove(
                              values.sections,
                              sec_index,
                              setFieldValue,
                            )
                          }
                          src={require("../../../assets/images/removeIcon.svg")}
                          alt="remove"
                          style={{
                            marginRight: 5,
                            marginBottom: 16,
                            cursor: "pointer",
                          }}
                        />
                      )}
                    </Row>
                    <FormLabel
                      style={{
                        fontFamily: theme.fonts.primaryFontSemiBold,
                        fontSize: 10,
                        color: COLORS.INPUT_LABEL,
                      }}
                    >
                      QUESTION
                    </FormLabel>
                    <CustomInputField
                      className={"input-white"}
                      autoComplete={"new-password"}
                      type={"text"}
                      value={section.question}
                      error={
                        errors.sections?.length &&
                        touched.sections?.length &&
                        errors?.sections[sec_index]?.question &&
                        touched?.sections[sec_index]?.question
                      }
                      helperText={
                        errors.sections?.length &&
                        touched.sections?.length &&
                        touched?.sections[sec_index]?.question &&
                        errors?.sections[sec_index]?.question
                      }
                      id={`sections[${sec_index}].question`}
                      name={`sections[${sec_index}].question`}
                      variant="outlined"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      style={{ marginTop: 6, marginBottom: 20 }}
                    />
                    <FormLabel
                      style={{
                        fontFamily: theme.fonts.primaryFontSemiBold,
                        fontSize: 10,
                        color: COLORS.INPUT_LABEL,
                      }}
                    >
                      ANSWER
                    </FormLabel>

                    <Relative>
                      <CustomTextArea
                        className={"input-white"}
                        rowsMin={5}
                        autoComplete={"new-password"}
                        value={section.answer}
                        error={
                          errors.sections?.length &&
                          touched.sections?.length &&
                          errors?.sections[sec_index]?.answer &&
                          touched?.sections[sec_index]?.answer
                        }
                        id={`sections[${sec_index}].answer`}
                        maxLength={1000}
                        name={`sections[${sec_index}].answer`}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{ marginTop: 6 }}
                      />
                      <HelperText>
                        {errors.sections?.length &&
                          touched.sections?.length &&
                          touched?.sections[sec_index]?.answer &&
                          errors?.sections[sec_index]?.answer}
                      </HelperText>
                    </Relative>
                  </Width>
                </Section>
              ))}
              {/* <WrapperButtons>
                      <HyperLink style={{ marginTop: 15, marginBottom: 37 }}>
                        {labels.add_item}
                      </HyperLink>
                    </WrapperButtons> */}
              <ButtonWrapper>
                <SecondaryCTAButton
                  onClick={() => addSection(setFieldValue, values.sections)}
                  style={{
                    paddingLeft: 0,
                    color: COLORS.TRANSCRIPT_GRAY,
                  }}
                >
                  <AddCircleOutline
                    style={{
                      marginRight: "10px",
                      marginLeft: "5px",
                      color: COLORS.TRANSCRIPT_GRAY,
                    }}
                  />{" "}
                  Add Option
                </SecondaryCTAButton>
              </ButtonWrapper>
              <FormControl>
                <ButtonContainer>
                  {custom_buttons.map((button) => (
                    <PrimaryCTAButton
                      style={{ width: "auto", marginLeft: 8 }}
                      onClick={() =>
                        handleButtonClick(button, resetForm, handleSubmit)
                      }
                    >
                      {button.label}
                    </PrimaryCTAButton>
                  ))}
                </ButtonContainer>
              </FormControl>
            </form>
          )}
        </Formik>
      </Container>
    </>
  );
};

export default Help;

const Container = styled.div`
  padding: 42px 46px;
  display: flex;
  flex-direction: column;
`;

const H2 = styled.h2`
  font-family: ${theme.fonts.primaryFontBold};
  color: ${COLORS.COLOR_DARK};
  font-size: 14px;
  margin-bottom: 16px;
`;

const Section = styled.div`
  margin-top: 7px;
`;

const Width = styled.div`
  width: 558px;
`;

const Relative = styled.div`
  position: relative;
`;

const CustomTextArea = styled(TextareaAutosize)`
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  font-size: 16px;
  color: ${COLORS.COLOR_DARK} !important;
  font-family: ${theme.fonts.primaryFontSemiBold};
  /* min-height: 89px; */
  border-radius: 6px;
  border: solid 0.5px #e1e3ee;
  background-color: #ffffff;
  outline: none;
  padding: 15px;
  :hover {
    border: solid 0.5px black;
  }
  ${({ error }) =>
    error &&
    css`
      border: solid 0.5px #f44336;
      :hover {
        border: solid 0.5px #f44336;
      }
    `}
`;

const HelperText = styled.div`
  position: absolute;
  left: 3px;
  bottom: -12px;
  position: absolute;
  font-size: 10px;
  font-family: openSans-SemiBold, sans-serif;
  color: #f44336;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
